import React, { useEffect, useState } from 'react'
import {
  testAudioOutputDevice,
  AudioOutputTest,
  testAudioInputDevice,
  AudioInputTest,
} from '@twilio/rtc-diagnostics'

function useAudioTest() {
  const [audioInputReport, setAudioInputReport] = useState(null)
  const [audioOutputReport, setAudioOutputReport] = useState(null)

  const testAudioInput = async () => {
    return new Promise((resolve, reject) => {
      const audioInputDeviceTest = testAudioInputDevice()
      audioInputDeviceTest.on(AudioInputTest.Events.Volume, volume => {})
      audioInputDeviceTest.on(AudioInputTest.Events.Error, error => {
        console.error('Audio Input Error', error)
      })
      setTimeout(() => {
        audioInputDeviceTest.stop()
      }, 10000)
      audioInputDeviceTest.on(AudioInputTest.Events.End, report => {
        setAudioInputReport(report)
        if (report?.errors?.length !== 0) {
          reject(report)
        } else {
          resolve(report)
        }
      })
    })
  }
  const testAudioOutput = async () => {
    return new Promise((resolve, reject) => {
      const audioOutputDeviceTest = testAudioOutputDevice()
      audioOutputDeviceTest.on(AudioOutputTest.Events.Volume, volume => {})

      audioOutputDeviceTest.on(AudioOutputTest.Events.Error, error => {
        console.error('Audio Output Error', error)
      })
      setTimeout(() => {
        audioOutputDeviceTest.stop()
      }, 10000)
      audioOutputDeviceTest.on(AudioOutputTest.Events.End, report => {
        setAudioOutputReport(report)
        if (report?.errors?.length !== 0) {
          reject(report)
        } else {
          resolve(report)
        }
      })
    })
  }
  return {
    audioInputReport,
    audioOutputReport,
    setAudioInputReport,
    setAudioOutputReport,
    testAudioInput,
    testAudioOutput,
  }
}

export default useAudioTest
